import React from 'react';

import MoneyballSubPositions from './moneyballSubPositions/moneyballSubPositions';

const moneyballSubPositionsListReduxKey = '/hr/moneyball_sub_positions';

export function MoneyballPositionDetailsContainer() {
	return <MoneyballSubPositions reduxKey={moneyballSubPositionsListReduxKey} />;
}
